import { useEffect, useState } from 'react'
import { useStore } from 'effector-react'
import { fetchOrder, orderStore } from '../store/order'
import { generatePath, useHistory, useParams } from 'react-router-dom'
import ROUTES from '../routes'
import { optionsActions, optionsStore } from '../store/options'
import { choiceStore } from '../store/choice'
import { voucherStore } from '../store/voucher'

const useOrder = () => {
  const order = useStore(orderStore)
  const history = useHistory()
  const { orderNumber, transactionNumber } = useParams()
  if (!order) {
    const goHome = (state) => {
      history.replace(ROUTES.home, state)
    }
    if (!orderNumber || !transactionNumber) goHome({ error: true })
    fetchOrder.fail.watch((res) => {
      const status = res.error.message
      if (status === '401') {
        optionsActions.setOption({ isRemainingAccessCount: false })
      }
      goHome(status === '404' ? { error: true } : null)
    })
    fetchOrder({ orderNumber, transactionNumber })
  }
  return order
}

const useVoucher = () => {
  const voucher = useStore(voucherStore)
  const history = useHistory()
  if (!voucher) {
    history.replace(ROUTES.home)
  }
  return voucher
}

const useError = () => {
  const history = useHistory()
  const [error, setError] = useState(false)

  useEffect(() => {
    if (history.action === 'REPLACE' && history.location.state && history.location.state.error) {
      setError(true)
      history.replace(history.location.pathname, null)
    }
  }, [history])

  return [error, setError]
}

const useChoice = () => {
  const choice = useStore(choiceStore)
  const history = useHistory()
  const { orderNumber, transactionNumber } = useParams()
  if (!choice && orderNumber && transactionNumber) {
    history.replace(generatePath(ROUTES.order, { orderNumber, transactionNumber }))
  }
  return choice
}

const useTranslator = () => {
  const options = useStore(optionsStore)
  const { i18n } = options
  return (key, ...params) => {
    const chunks = key.split('.')
    let currentTranslation = i18n
    chunks.forEach((chunk) => {
      currentTranslation = currentTranslation[chunk]
    })
    if (currentTranslation && params && params.length > 0) {
      params.forEach((param, index) => {
        currentTranslation = currentTranslation.replace('$' + index, param)
      })
    }
    return currentTranslation
  }
}

const useOptions = () => {
  const options = useStore(optionsStore)
  const isOrderRefundable = (order) => {
    return options.refundableStatus.includes(order.status)
  }
  return { ...options, isOrderRefundable }
}

export { useOrder, useVoucher, useError, useChoice, useTranslator, useOptions }
